import { render, staticRenderFns } from "./OpenPeriodSection.vue?vue&type=template&id=aebae0ae&"
import script from "./OpenPeriodSection.vue?vue&type=script&lang=js&"
export * from "./OpenPeriodSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports